"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSdk = exports.IsApiReadyDocument = exports.GetBasicUserDataDocument = exports.UserOccupation = exports.UserInviteStatus = exports.UserFittingPreference = exports.UserChallengeStatus = exports.UserApps = exports.TransportEnum = exports.SortOrderEnum = exports.SortField = exports.SortDirection = exports.SettlementStatus = exports.SalesrepType = exports.SUPPORT_TICKET_DEPARTMENT = exports.RewardStatus = exports.ParticipantCampaignConfigStates = exports.JoinType = exports.JoinCodeType = exports.HubspotSortDirection = exports.FundraiserUserImportType = exports.EventDateStatus = exports.EventAttendeeRequestStatus = exports.DriveScheduleTimeFrame = exports.DriveFieldType = exports.DriveEventStatus = exports.DriveAttendanceStatus = exports.DonationLevels = exports.ContactTemplateType = exports.ContactTemplateMedium = exports.CampaignStatus = exports.CampaignSmsInviteStatus = exports.CampaignMemberAssociation = exports.CampaignKycType = exports.CampaignKycStatusEnum = exports.CampaignKycStatus = exports.BasicCampaignStatus = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
var BasicCampaignStatus;
(function (BasicCampaignStatus) {
    BasicCampaignStatus["ACTIVE"] = "ACTIVE";
    BasicCampaignStatus["CLOSED"] = "CLOSED";
    BasicCampaignStatus["UPCOMING"] = "UPCOMING";
})(BasicCampaignStatus = exports.BasicCampaignStatus || (exports.BasicCampaignStatus = {}));
/** Fixed statuses for a campaigns kyc */
var CampaignKycStatus;
(function (CampaignKycStatus) {
    CampaignKycStatus["action_required"] = "action_required";
    CampaignKycStatus["in_review"] = "in_review";
    CampaignKycStatus["require_docs"] = "require_docs";
    CampaignKycStatus["unsubmitted"] = "unsubmitted";
    CampaignKycStatus["unverified"] = "unverified";
    CampaignKycStatus["verified"] = "verified";
})(CampaignKycStatus = exports.CampaignKycStatus || (exports.CampaignKycStatus = {}));
var CampaignKycStatusEnum;
(function (CampaignKycStatusEnum) {
    CampaignKycStatusEnum["ACTION_NEEDED"] = "ACTION_NEEDED";
    CampaignKycStatusEnum["PENDING"] = "PENDING";
    CampaignKycStatusEnum["UNSUBMITTED"] = "UNSUBMITTED";
    CampaignKycStatusEnum["VERIFIED"] = "VERIFIED";
})(CampaignKycStatusEnum = exports.CampaignKycStatusEnum || (exports.CampaignKycStatusEnum = {}));
/** Fixed type for a campaigns kyc */
var CampaignKycType;
(function (CampaignKycType) {
    CampaignKycType["stripe"] = "stripe";
    CampaignKycType["wepay"] = "wepay";
})(CampaignKycType = exports.CampaignKycType || (exports.CampaignKycType = {}));
var CampaignMemberAssociation;
(function (CampaignMemberAssociation) {
    CampaignMemberAssociation["ADMIN"] = "ADMIN";
    CampaignMemberAssociation["COACH"] = "COACH";
    CampaignMemberAssociation["COCOACH"] = "COCOACH";
    CampaignMemberAssociation["COPARTICIPANT"] = "COPARTICIPANT";
    CampaignMemberAssociation["PARTICIPANT"] = "PARTICIPANT";
    CampaignMemberAssociation["SUPPORTER"] = "SUPPORTER";
})(CampaignMemberAssociation = exports.CampaignMemberAssociation || (exports.CampaignMemberAssociation = {}));
var CampaignSmsInviteStatus;
(function (CampaignSmsInviteStatus) {
    CampaignSmsInviteStatus["PRELOADED"] = "PRELOADED";
    CampaignSmsInviteStatus["PRELOAD_QUEUED"] = "PRELOAD_QUEUED";
    CampaignSmsInviteStatus["QUEUED"] = "QUEUED";
})(CampaignSmsInviteStatus = exports.CampaignSmsInviteStatus || (exports.CampaignSmsInviteStatus = {}));
var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["ACTIVE"] = "ACTIVE";
    CampaignStatus["APPROVED"] = "APPROVED";
    CampaignStatus["ARCHIVE"] = "ARCHIVE";
    CampaignStatus["CLOSED"] = "CLOSED";
    CampaignStatus["DELETED"] = "DELETED";
    CampaignStatus["FINAL"] = "FINAL";
    CampaignStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    CampaignStatus["SETTLED"] = "SETTLED";
})(CampaignStatus = exports.CampaignStatus || (exports.CampaignStatus = {}));
var ContactTemplateMedium;
(function (ContactTemplateMedium) {
    ContactTemplateMedium["EMAIL"] = "EMAIL";
    ContactTemplateMedium["TEXT_MESSAGE"] = "TEXT_MESSAGE";
})(ContactTemplateMedium = exports.ContactTemplateMedium || (exports.ContactTemplateMedium = {}));
var ContactTemplateType;
(function (ContactTemplateType) {
    ContactTemplateType["GROUP_LEADER"] = "GROUP_LEADER";
    ContactTemplateType["PARTICIPANT"] = "PARTICIPANT";
})(ContactTemplateType = exports.ContactTemplateType || (exports.ContactTemplateType = {}));
var DonationLevels;
(function (DonationLevels) {
    DonationLevels["FIVE"] = "FIVE";
    DonationLevels["FOUR"] = "FOUR";
    DonationLevels["ONE"] = "ONE";
    DonationLevels["SIX"] = "SIX";
    DonationLevels["THREE"] = "THREE";
    DonationLevels["TWO"] = "TWO";
})(DonationLevels = exports.DonationLevels || (exports.DonationLevels = {}));
var DriveAttendanceStatus;
(function (DriveAttendanceStatus) {
    DriveAttendanceStatus["ATTENDING"] = "ATTENDING";
    DriveAttendanceStatus["NOT_ATTENDING"] = "NOT_ATTENDING";
})(DriveAttendanceStatus = exports.DriveAttendanceStatus || (exports.DriveAttendanceStatus = {}));
var DriveEventStatus;
(function (DriveEventStatus) {
    DriveEventStatus["CLOSED"] = "CLOSED";
    DriveEventStatus["EMAIL_SENT"] = "EMAIL_SENT";
    DriveEventStatus["NOT_ATTENDING"] = "NOT_ATTENDING";
    DriveEventStatus["PENDING"] = "PENDING";
    DriveEventStatus["REGISTERED"] = "REGISTERED";
})(DriveEventStatus = exports.DriveEventStatus || (exports.DriveEventStatus = {}));
var DriveFieldType;
(function (DriveFieldType) {
    DriveFieldType["HTML"] = "HTML";
    DriveFieldType["LINK"] = "LINK";
    DriveFieldType["TEXT"] = "TEXT";
})(DriveFieldType = exports.DriveFieldType || (exports.DriveFieldType = {}));
var DriveScheduleTimeFrame;
(function (DriveScheduleTimeFrame) {
    DriveScheduleTimeFrame["AFTERNOON"] = "AFTERNOON";
    DriveScheduleTimeFrame["EVENING"] = "EVENING";
    DriveScheduleTimeFrame["MORNING"] = "MORNING";
})(DriveScheduleTimeFrame = exports.DriveScheduleTimeFrame || (exports.DriveScheduleTimeFrame = {}));
var EventAttendeeRequestStatus;
(function (EventAttendeeRequestStatus) {
    EventAttendeeRequestStatus["NO_REQUEST"] = "NO_REQUEST";
    EventAttendeeRequestStatus["PROCESSED"] = "PROCESSED";
    EventAttendeeRequestStatus["REQUEST"] = "REQUEST";
})(EventAttendeeRequestStatus = exports.EventAttendeeRequestStatus || (exports.EventAttendeeRequestStatus = {}));
var EventDateStatus;
(function (EventDateStatus) {
    EventDateStatus["Active"] = "Active";
    EventDateStatus["Closed"] = "Closed";
    EventDateStatus["Upcoming"] = "Upcoming";
})(EventDateStatus = exports.EventDateStatus || (exports.EventDateStatus = {}));
var FundraiserUserImportType;
(function (FundraiserUserImportType) {
    FundraiserUserImportType["csv_import"] = "csv_import";
    FundraiserUserImportType["rollover"] = "rollover";
})(FundraiserUserImportType = exports.FundraiserUserImportType || (exports.FundraiserUserImportType = {}));
var HubspotSortDirection;
(function (HubspotSortDirection) {
    HubspotSortDirection["ASCENDING"] = "ASCENDING";
    HubspotSortDirection["DESCENDING"] = "DESCENDING";
})(HubspotSortDirection = exports.HubspotSortDirection || (exports.HubspotSortDirection = {}));
var JoinCodeType;
(function (JoinCodeType) {
    JoinCodeType["GROUP_LEADER"] = "GROUP_LEADER";
    JoinCodeType["INVALID"] = "INVALID";
    JoinCodeType["PARTICIPANT"] = "PARTICIPANT";
})(JoinCodeType = exports.JoinCodeType || (exports.JoinCodeType = {}));
var JoinType;
(function (JoinType) {
    JoinType["FANX"] = "FANX";
    JoinType["SMA"] = "SMA";
})(JoinType = exports.JoinType || (exports.JoinType = {}));
var ParticipantCampaignConfigStates;
(function (ParticipantCampaignConfigStates) {
    ParticipantCampaignConfigStates["COMPLETED"] = "COMPLETED";
    ParticipantCampaignConfigStates["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    ParticipantCampaignConfigStates["NOT_COMPLETED"] = "NOT_COMPLETED";
    ParticipantCampaignConfigStates["SKIPPED"] = "SKIPPED";
})(ParticipantCampaignConfigStates = exports.ParticipantCampaignConfigStates || (exports.ParticipantCampaignConfigStates = {}));
var RewardStatus;
(function (RewardStatus) {
    RewardStatus["DELIVERED"] = "DELIVERED";
    RewardStatus["FAILED"] = "FAILED";
    RewardStatus["PENDING"] = "PENDING";
    RewardStatus["SENT"] = "SENT";
})(RewardStatus = exports.RewardStatus || (exports.RewardStatus = {}));
var SUPPORT_TICKET_DEPARTMENT;
(function (SUPPORT_TICKET_DEPARTMENT) {
    SUPPORT_TICKET_DEPARTMENT["ACCOUNTS"] = "ACCOUNTS";
    SUPPORT_TICKET_DEPARTMENT["HUBSPOT"] = "HUBSPOT";
    SUPPORT_TICKET_DEPARTMENT["IT"] = "IT";
    SUPPORT_TICKET_DEPARTMENT["PEP"] = "PEP";
    SUPPORT_TICKET_DEPARTMENT["SALES"] = "SALES";
    SUPPORT_TICKET_DEPARTMENT["SPONSOR"] = "SPONSOR";
    SUPPORT_TICKET_DEPARTMENT["STORE"] = "STORE";
    SUPPORT_TICKET_DEPARTMENT["WALLET"] = "WALLET";
    SUPPORT_TICKET_DEPARTMENT["WAREHOUSE"] = "WAREHOUSE";
})(SUPPORT_TICKET_DEPARTMENT = exports.SUPPORT_TICKET_DEPARTMENT || (exports.SUPPORT_TICKET_DEPARTMENT = {}));
var SalesrepType;
(function (SalesrepType) {
    SalesrepType["ACCOUNT_MANAGER"] = "ACCOUNT_MANAGER";
    SalesrepType["SALES_REP"] = "SALES_REP";
})(SalesrepType = exports.SalesrepType || (exports.SalesrepType = {}));
/** Fixed statuses for a campaigns settlement status */
var SettlementStatus;
(function (SettlementStatus) {
    SettlementStatus["IN_REVIEW"] = "IN_REVIEW";
    SettlementStatus["UNSUBMITTED"] = "UNSUBMITTED";
    SettlementStatus["VERIFIED"] = "VERIFIED";
})(SettlementStatus = exports.SettlementStatus || (exports.SettlementStatus = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "ASC";
    SortDirection["DESC"] = "DESC";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
var SortField;
(function (SortField) {
    SortField["ADVANCED_FUNDS"] = "ADVANCED_FUNDS";
    SortField["CLOSED_STATUS"] = "CLOSED_STATUS";
    SortField["DAYS_LEFT"] = "DAYS_LEFT";
    SortField["END_DATE"] = "END_DATE";
    SortField["KYC_STATUS"] = "KYC_STATUS";
    SortField["NAME"] = "NAME";
    SortField["PARTICIPATION"] = "PARTICIPATION";
    SortField["PRELOAD"] = "PRELOAD";
    SortField["SETTLEMENT_DETAILS"] = "SETTLEMENT_DETAILS";
    SortField["START_DATE"] = "START_DATE";
    SortField["STATUS"] = "STATUS";
    SortField["TOTAL_RAISED"] = "TOTAL_RAISED";
})(SortField = exports.SortField || (exports.SortField = {}));
var SortOrderEnum;
(function (SortOrderEnum) {
    SortOrderEnum["asc"] = "asc";
    SortOrderEnum["desc"] = "desc";
})(SortOrderEnum = exports.SortOrderEnum || (exports.SortOrderEnum = {}));
var TransportEnum;
(function (TransportEnum) {
    TransportEnum["email"] = "email";
    TransportEnum["sms"] = "sms";
})(TransportEnum = exports.TransportEnum || (exports.TransportEnum = {}));
var UserApps;
(function (UserApps) {
    UserApps["connect"] = "connect";
    UserApps["drive"] = "drive";
    UserApps["home"] = "home";
    UserApps["insights"] = "insights";
    UserApps["manage"] = "manage";
    UserApps["raise"] = "raise";
    UserApps["spend"] = "spend";
    UserApps["spend_new"] = "spend_new";
    UserApps["sponsor"] = "sponsor";
    UserApps["store"] = "store";
    UserApps["wallet"] = "wallet";
})(UserApps = exports.UserApps || (exports.UserApps = {}));
var UserChallengeStatus;
(function (UserChallengeStatus) {
    UserChallengeStatus["AWAITING"] = "AWAITING";
    UserChallengeStatus["COMPLETED"] = "COMPLETED";
    UserChallengeStatus["SKIPPED"] = "SKIPPED";
})(UserChallengeStatus = exports.UserChallengeStatus || (exports.UserChallengeStatus = {}));
var UserFittingPreference;
(function (UserFittingPreference) {
    UserFittingPreference["MENS"] = "MENS";
    UserFittingPreference["WOMENS"] = "WOMENS";
})(UserFittingPreference = exports.UserFittingPreference || (exports.UserFittingPreference = {}));
var UserInviteStatus;
(function (UserInviteStatus) {
    UserInviteStatus["ACCEPTED"] = "ACCEPTED";
    UserInviteStatus["DECLINED"] = "DECLINED";
    UserInviteStatus["PENDING"] = "PENDING";
})(UserInviteStatus = exports.UserInviteStatus || (exports.UserInviteStatus = {}));
var UserOccupation;
(function (UserOccupation) {
    UserOccupation["district_administrator"] = "district_administrator";
    UserOccupation["financial_administrator"] = "financial_administrator";
    UserOccupation["group_leader"] = "group_leader";
    UserOccupation["other"] = "other";
    UserOccupation["parent"] = "parent";
    UserOccupation["school_director"] = "school_director";
    UserOccupation["state_administrator"] = "state_administrator";
    UserOccupation["student_or_participant"] = "student_or_participant";
    UserOccupation["unknown"] = "unknown";
})(UserOccupation = exports.UserOccupation || (exports.UserOccupation = {}));
exports.GetBasicUserDataDocument = (0, graphql_tag_1.default) `
    query GetBasicUserData {
  me {
    id
    email
    firstName
    lastName
    permissions
  }
}
    `;
exports.IsApiReadyDocument = (0, graphql_tag_1.default) `
    query IsApiReady {
  apiReady @client
}
    `;
function getSdk(requester) {
    return {
        GetBasicUserData(variables, options) {
            return requester(exports.GetBasicUserDataDocument, variables, options);
        },
        IsApiReady(variables, options) {
            return requester(exports.IsApiReadyDocument, variables, options);
        }
    };
}
exports.getSdk = getSdk;
